/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodDrinkMilkIcon24Solid = forwardRef('FoodDrinkMilkIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M4 19.25V9.952a2 2 0 0 1 .438-1.25l2.254-2.818L10 9.776V22H6.75A2.75 2.75 0 0 1 4 19.25Z" }),
        React.createElement("path", { d: "M11.5 22h5.75A2.75 2.75 0 0 0 20 19.25V10h-8.5v12Z" }),
        React.createElement("path", { d: "m19.4 8.5-2.4-3H8.334l2.55 3H19.4Z" }),
        React.createElement("path", { d: "M17 4V2.5A1.5 1.5 0 0 0 15.5 1h-7A1.5 1.5 0 0 0 7 2.5V4h10Z" })));
});
